import { Component,AfterViewInit, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs/internal/Observable';
import { Subscriber } from 'rxjs/internal/Subscriber';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { AlertboxComponent } from '../alertbox/alertbox.component';
import { invalid } from '@angular/compiler/src/render3/view/util';
import { HttpErrorResponse } from '@angular/common/http';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { SafeUrl } from '@angular/platform-browser';
import { finalize } from 'rxjs/operators';
import { Router } from '@angular/router';
@Component({
  selector: 'app-photo-signature-details',
  templateUrl: './photo-signature-details.component.html',
  styleUrls: ['./photo-signature-details.component.scss']
})
export class PhotoSignatureDetailsComponent implements OnInit {
  @Input() tabName: string = '';
  @Output() next = new EventEmitter<void>();
  // @Output() prev = new EventEmitter<void>();
  @Output() prev = new EventEmitter<boolean>();
  @Output() first = new EventEmitter<void>();
  dialogRef: MatDialogRef<any>;
  userImage: any;
  errormessage: string;
  signatureImage: any;
  userSign: string;
  fileName: string;
  uploadDoc: any;
  proId: any;
  disabled = false;
  tabs : string;
  displayName : any;
  Course: any;
  College: any;
  isSaving: boolean = false;
  imageChangedEvent: Event | null = null;
  croppedImage: SafeUrl  = '';
  signatureFileExt: string;
  photoFileExt: string;
  SnNo: any;
  constructor(private fb: FormBuilder,private modalPopupService: ModalpopService, private router: Router,
    public umsService: UmsService, private spinner: NgxSpinnerService) { }
  photoSignDetailsForm: FormGroup;
  submitButton = true;
  updateButton = false;
  showmsg = false
  StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
  session = sessionStorage.getItem('session');
  studentId = sessionStorage.getItem('StudentRGID');
  isPrepopulationEmpty: boolean;
  prepopulationFlag: boolean;


  ngOnInit(): void {
    this.prepopulationFlag = false;
    this.isPrepopulationEmpty = true;
    this.session = sessionStorage.getItem('session');
    this.StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
    this.submitButton = true;
    this.updateButton = false;
    this.disabled = false;
    this.photoSignDetailsForm = this.fb.group({
      StuId: new FormControl(this.StudentPersonalId),
      StuRgNo: new FormControl(this.studentId),
      StuPhoto: new FormControl('',Validators.required),
      StuSignature: new FormControl('',Validators.required),

    });
    // this.getScrutiny();
    this.getSecretData();
    this.getApplyData();
    this.prepopulationContact();
    this.prepopulation();
    // this.userImage = "../../assets/images/user2.png";
    // this.signatureImage ="../../assets/images/sign.png";
  }

  getSecretData() {
    this.spinner.show();
    let payload = {};
    this.umsService.getSecretData().subscribe((res) => {
      if(res.status){
        this.SnNo = res.projectPharam['SnNo'];
        this.spinner.hide();
      }
      else{
        this.spinner.hide();
      }
    },(ERROR:HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  getFeeStatus(StuId) {
    const payload = {};
    payload['StuId'] = StuId;
    payload['SnNo'] = this.session;
    this.umsService.getFeeStatus(payload).subscribe(res => {
      if (res.status) {
        console.log('fees status response i get is', res.data);
        this.getScrutiny(StuId)
      }
      else {
        this.disabled = false;
      }
    }, (ERROR: HttpErrorResponse) => {
      this.disabled = false;
    })
  }


  getScrutiny(StuId) {
    const payload = {};
    payload['StudentId'] = StuId
    this.umsService.fetchScrutinyLock(payload).subscribe(res => {
      this.tabs = res.data[0].Tabs;
      // if(res.data.length == 0 || res.data[0]['Status'] == 'DCERR'){
      //   this.disabled = false
      // }
      // else{
      //   this.disabled = true;
      // }
      if (res.data.length == 0 || res.data[0]['Status'] == 'DCERR') {
        if(res.data[0].Tabs.includes('Photo & Signatur')){
          this.disabled = false;
        }else{
          this.disabled = true;
        }
      }
      else {
        this.disabled = true;
      }
    });
  }

submitCheck(){
  if((this.userImage == ''  && this.signatureImage == '') || (this.userImage == null  && this.signatureImage == null)){
    this.photoSignDetailsForm.get('StuSignature').markAsTouched();
    this.photoSignDetailsForm.get('StuPhoto').markAsTouched();
    
  } 
  else if((this.userImage == null || this.userImage == '')  && (this.signatureImage != null || this.signatureImage != '')){
    // this.photoSignDetailsForm.get('StuSignature').markAsTouched();
    this.photoSignDetailsForm.get('StuPhoto').markAsTouched();
    
  }
  else if((this.userImage != null || this.userImage != '')  && (this.signatureImage == null || this.signatureImage =='')){
    this.photoSignDetailsForm.get('StuSignature').markAsTouched();
    // this.photoSignDetailsForm.get('StuPhoto').markAsTouched();
    
  }
  else{
    this.save();
  }
}
  save() {
    this.isSaving = true;
    // this.submitButton = true;
    // this.updateButton = false;
    const payload = this.photoSignDetailsForm.value;
    this.saveFile('photo', this.userImage);
    this.saveFile('sign', this.signatureImage);
    payload.StuId = parseInt(payload.StuId);
    payload.StuRgNo = parseInt(payload.StuRgNo);
    payload.StuPhoto = this.userImage;
    payload.StuSignature = this.signatureImage;
    payload.LoginId = parseInt(sessionStorage.getItem('StudentRGID'));
    if(payload.StuPhoto == ''){
      let img = '../../assets/images/user2.png'
      sessionStorage.setItem('ProfileImg',img);
      this.umsService.getNoimg(img)
    }else{
      sessionStorage.setItem('ProfileImg',this.userImage);
    }
   
    this.umsService.addPhotoSignDetails(payload).subscribe(res => {
      if(res.status){
        this.isSaving = false;
        this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.next.emit();
        })
         
      }
      else{
        this.isSaving = false;
        this.spinner.hide();
      }
    },(ERROR: HttpErrorResponse) => {
      this.isSaving = false;
      this.spinner.hide();
    });
  }


  prepopulation() {
    this.spinner.show();
    let payload = {};
    payload['StuId'] = this.StudentPersonalId;
    this.umsService.fetchPhotoSignDetails(payload).subscribe((res) => {
      console.log("res status in photo signature details: ",res.status);
      sessionStorage.setItem('ProfileImg',res.data[0].StuPhoto);
      const data = res.data[0];
      this.proId = res.data[0].StuProfId;
      this.spinner.hide();
      if (res.status) {
        if (res.data.length > 0) {
          this.isPrepopulationEmpty = false;
          this.umsService.disable6 = false;
          this.submitButton = false;
          this.updateButton = true;
          this.photoSignDetailsForm = this.fb.group({
            StuId: new FormControl(data.StuId),
            StuRgNo: new FormControl(data.StuRgNo),
            StuPhoto: new FormControl(data.StuPhoto,Validators.required),
            StuSignature: new FormControl(data.StuSignature,Validators.required),
          });
          this.userImage = res.data[0].StuPhoto
          this.signatureImage = res.data[0].StuSignature
          if(res.data[0].StuPhoto == ''){
            let img = '../../assets/images/user2.png'
            sessionStorage.setItem('ProfileImg','../../assets/images/user2.png');
            this.umsService.getNoimg(img)
          }else{
            sessionStorage.setItem('ProfileImg',this.userImage);
          }
          this.getFeeStatus(res.data[0].StuId)
        }
        else {
          console.log("in else condition");
          this.isPrepopulationEmpty = true;
          // this.submitButton = true;
          // this.updateButton = false;

        }
      } else {
        this.isPrepopulationEmpty = true;
        console.log("prepopulation empty in photo signature details: ",this.isPrepopulationEmpty);
      }
    })
  }

  prepopulation2() {
    this.spinner.show();
    let payload = {};
    payload['StuId'] = this.StudentPersonalId;
    this.umsService.fetchPhotoSignDetails(payload).subscribe((res) => {
      this.spinner.hide();
      sessionStorage.setItem('ProfileImg',res.data[0].StuPhoto);
      const data = res.data[0];
      this.proId = res.data[0].StuProfId;
      if (res.status) {
        if (res.data.length > 0) {
          this.umsService.disable6 = false;
          // this.submitButton = false;
          // this.updateButton = true;
          // this.photoSignDetailsForm = this.fb.group({
          //   StuId: new FormControl(data.StuId),
          //   StuRgNo: new FormControl(data.StuRgNo),
          //   StuPhoto: new FormControl(data.StuPhoto),
          //   StuSignature: new FormControl(data.StuSignature),
          // });
          // this.userImage = res.data[0].StuPhoto
          // this.signatureImage = res.data[0].StuSignature
          // if(res.data[0].StuPhoto == ''){
          //   let img = '../../assets/images/user2.png'
          //   sessionStorage.setItem('ProfileImg','../../assets/images/user2.png');
          //   this.umsService.getNoimg(img)
          // }else{
          //   sessionStorage.setItem('ProfileImg',this.userImage);
          // }
        }
        else {
          // this.submitButton = true;
          // this.updateButton = false;
          this.umsService.disable5 = true;
        }
      } else {

      }
    })
  }

updateCheck(){
  if(this.userImage == '' || this.userImage == null  || this.signatureImage == '' || this.signatureImage == null){
    this.photoSignDetailsForm.get('StuSignature').markAsTouched();
    this.photoSignDetailsForm.get('StuPhoto').markAsTouched();
   
  }else{
    this.update();
  }
}
// getTabName(e){
//   this.displayName = e;
// }

getTabDisplayName(): string {
  return `Current Tab: ${this.tabName}`;
}

  update() {
        this.UpdateScrutiny();

  }
UpdateScrutiny(){
  this.spinner.show();
  let payload = this.photoSignDetailsForm.value;
  this.saveFile('photo', this.userImage);
  this.saveFile('sign', this.signatureImage);
  payload.StuId = parseInt(payload.StuId);
  payload.StuRgNo = parseInt(payload.StuRgNo);
  payload.StuPhoto = this.userImage;
  payload.StuSignature = this.signatureImage;
  payload['StuProfId'] = this.proId;
  sessionStorage.setItem('ProfileImg',this.userImage);
  payload.LoginId = parseInt(sessionStorage.getItem('StudentRGID'));
  this.umsService.updatePhotoSignDetails(payload).subscribe(res => {
    if(res.status){
      this.umsService.setTabSaved('photoSignatureTab');
      if(payload.StuPhoto == ''){
        let img = '../../assets/images/user2.png'
        sessionStorage.setItem('ProfileImg','../../assets/images/user2.png');
        this.umsService.getNoimg(img);
        
        
      }else{
        sessionStorage.setItem('ProfileImg',payload.StuPhoto);
        
      }
      this.spinner.hide();
      let data = {}
      data['message'] = res.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data); 
        // Check only scrutiny error tabs
    if (this.tabs &&
    this.umsService.isRequiredTabsSaved(this.tabs)) {
    const confirmData = {};
    confirmData['message'] =
      'Are You Sure You Have Updated ' +
      this.tabs +
      ' Tabs. Do You Want To Proceed?';

    confirmData['title'] = 'Alert';
    confirmData['icon'] = 'fa fa-question';

    this.dialogRef =
      this.modalPopupService.openPopup<ConformationModelComponent>(
        ConformationModelComponent,
        confirmData
      );

    this.dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        this.UpdScrtDetails();
        if (this.tabs.includes('Wrong Payment')) {
        this.router.navigate(['/Fees']);
      }
      }
    });
  }
      this.next.emit();
  
    }
    
  });
}

saveFile(type: string, base64Data: string) {
  const payload = {
    filePath:'photo_sign/' + parseInt(this.StudentPersonalId) +'_' + type,
    base64: base64Data
  };

  this.umsService.saveFiles(payload).subscribe(
    (res) => {
      this.spinner.hide();
      if (!res.status) this.isSaving = false;
    },
    (error: HttpErrorResponse) => {
      this.isSaving = false;
      this.spinner.hide();
    }
  );
}

  onChange1($event: Event) {
    const file = ($event.target as HTMLInputElement).files[0];
    const fileName = file.name;
    this.fileName = fileName;
    if (file.size >= 512000) {
      // this.apimicroservice.openSnackbar("Max upload size allowed is 3mb");
      this.errormessage = "Please upload file less than 500 KB";
    
        let data = {}
        data['message'] = this.errormessage;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          // this.dialogRef.close();
          // this.ngOnInit();
          // this.dialogRef2.close();
        });
     
    } else {
      this.errormessage = '';
      let ext = fileName.substring(fileName.lastIndexOf(".") + 1);
    
      if (
        ext.toLowerCase() == "png" ||
        ext.toLowerCase() == "jpg" ||
        ext.toLowerCase() == "jpeg"
        // ext.toLowerCase() == "pdf"
      ) {
        this.photoFileExt = ext;
        this.convertToBase641(file);
      }
      else{
        let data = {}
        data['message'] = 'File not support'
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          // this.dialogRef.close();
          // this.ngOnInit();
          // this.dialogRef2.close();
        });
      }
    }
  }

  convertToBase641(file: File) {
    const observable = new Observable((subscriber: Subscriber<any>) => {
      this.readFile1(file, subscriber);
    });
   
    observable.subscribe((d) => {
      this.userImage = d;
    if(this.userImage == '' || this.userImage == null){
      // this.photoSignDetailsForm.get('StuSignature').markAsTouched();
      this.photoSignDetailsForm.get('StuPhoto').markAsTouched();
    }else{
      // this.photoSignDetailsForm.get('StuSignature').markAsUntouched();
      this.photoSignDetailsForm.get('StuPhoto').markAsUntouched();
    }
   
    });
  }
  readFile1(file: File, subscriber: Subscriber<any>) {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      subscriber.next(fileReader.result);
      subscriber.complete();
    };
    fileReader.onerror = (error) => {
      subscriber.error(error);
      subscriber.complete();
    };
  }


  onChangeSign($event: Event) {
    const file = ($event.target as HTMLInputElement).files[0];
    const fileName = file.name;
    this.fileName = fileName;
    if (file.size >= 512000) {
      // this.apimicroservice.openSnackbar("Max upload size allowed is 3mb");
      this.errormessage = "Please upload file less than 500 KB";
      let data = {}
      data['message'] = this.errormessage
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      this.dialogRef.afterClosed().subscribe(result => {
        // this.dialogRef.close();
        // this.ngOnInit();
        // this.dialogRef2.close();
        
    // this.qualificationDetailsForm.controls['fileUploadData'].setValue('');
      });
    } else {
      this.errormessage = '';
      let ext = fileName.substring(fileName.lastIndexOf(".") + 1);
    
      if (
        ext.toLowerCase() == "png" ||
        ext.toLowerCase() == "jpg" ||
        ext.toLowerCase() == "jpeg" 
        // ext.toLowerCase() == "pdf"
      ) {
        this.signatureFileExt = ext;
        this.convertToBase64Sign(file);
      }
      else{
        let data = {}
        data['message'] = 'File not support'
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          // this.dialogRef.close();
          // this.ngOnInit();
          // this.dialogRef2.close();
        });
      }
    }
  }
  convertToBase64Sign(file: File) {
    const observable = new Observable((subscriber: Subscriber<any>) => {
      this.readFile1(file, subscriber);
    });
   
    observable.subscribe((d) => {
      this.signatureImage = d;
      if(this.signatureImage == '' || this.signatureImage == null){
        this.photoSignDetailsForm.get('StuSignature').markAsTouched();
        // this.photoSignDetailsForm.get('StuPhoto').markAsTouched();
      }else{
        this.photoSignDetailsForm.get('StuSignature').markAsUntouched();
        // this.photoSignDetailsForm.get('StuPhoto').markAsUntouched();
      }
    });
  }
  readFileSign(file: File, subscriber: Subscriber<any>) {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      subscriber.next(fileReader.result);
      subscriber.complete();
    };
    fileReader.onerror = (error) => {
      subscriber.error(error);
      subscriber.complete();
    };
  }
  back() 
  {
    this.prev.emit(false);
  }
  UpdScrtDetails(){
    let payload = {};
    payload['StuId'] = parseInt(this.StudentPersonalId)
    payload['SessionId'] = parseInt(sessionStorage.getItem('session'));
    payload['CgCode'] = this.College
    payload['CoCode'] = this.Course
    this.umsService.UpdScrtDetails(payload).subscribe((res) => {
      if(res.status){
        this.first.emit();
        location.reload();
      }
      else{
        
      }
    })
  }
  getApplyData(){
    let payload = {}
    payload['LoginId'] = sessionStorage.getItem('loginId');
    this.umsService.getApplyData(payload).subscribe((res) => {
      if(res.status){
       this.Course = res.data[0]['Course'];
       this.College = res.data[0]['College']
      }
      else{
      
      }
    }, (ERROR: HttpErrorResponse) => {
    
    });
  }


  fileChangeEvent(event: Event): void {
    this.imageChangedEvent = event;
}
imageCropped(event) {
  // this.croppedImage = this.sanitizer.bypassSecurityTrustUrl(event.objectUrl);
  // event.blob can be used to upload the cropped image
}
imageLoaded(image) {
    // show cropper
}
cropperReady() {
    // cropper ready
}
loadImageFailed() {
    // show message
}

    prepopulationContact() {
    let payload = {};
    payload['StuId'] = this.StudentPersonalId;
    this.umsService.fetchContactDetails(payload).subscribe(res => {
      if (res.status) {
        if (res.data[0].StuNationality === 'OS') {
          this.umsService.studentProgressList['StudentReservation'] = 1;
        }
      } 
    }, (ERROR: HttpErrorResponse) => {
      
    })

  }

}